import axios from 'axios';

const AUTH_URL = 'https://auth.piosphere.ai/realms/piocloud/protocol/openid-connect/token';
const API_URL = 'https://api.v1.piosphere.ai/agent-manager/v1';

export const authenticate = async (username, password) => {
    try {
        const formData = new URLSearchParams({
            client_id: 'piocloud-client',
            grant_type: 'password',
            username: username,
            password: password
        });

        const response = await axios.post(AUTH_URL, formData, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAgentList = async (token) => {
    try {
        const response = await axios.get(`${API_URL}/agent`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {    
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAllAgents = async (token, search = null, page = null, limit = null) => {
    try {
        let url = `${API_URL}/agents`;
        const params = new URLSearchParams();
        
        if (search) params.append('search', search);
        if (page) params.append('page', page);
        if (limit) params.append('limit', limit);
        
        if (params.toString()) {
            url = `${url}?${params.toString()}`;
        }

        const response = await axios.get(url, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAvailableEndpoints = async (token) => {
    try {
        const response = await axios.get(`https://api.v1.piosphere.ai/agent-manager/public/v1/endpoints`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const getAgentById = async (token, agentId) => {
    try {
        const response = await axios.get(`${API_URL}/agent/${agentId}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const createAgent = async (token, agentData) => {
    try {
        const transformedData = {
            name: agentData.name,
            endpoint: agentData.endpoint || "",
            language: agentData.language || "en",
            model: agentData.model || "",
            models: agentData.models || []
        };

        if (!agentData.useDefaultSystemPrompt && agentData.system_prompt) {
            transformedData.system_prompt = agentData.system_prompt;
        }

        const response = await axios.post(
            `${API_URL}/agent`,
            transformedData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const updateAgent = async (token, agentId, agentData) => {
    try {
        const transformedData = {
            name: agentData.name,
            endpoint: agentData.endpoint || "",
            language: agentData.language || "en",
            model: agentData.model || "",
            models: agentData.models || []
        };

        if (!agentData.useDefaultSystemPrompt && agentData.system_prompt) {
            transformedData.system_prompt = agentData.system_prompt;
        }

        const response = await axios.put(
            `${API_URL}/agent/${agentId}`,
            transformedData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};

export const deleteAgent = async (token, agentId) => {
    try {
        const response = await axios.delete(
            `${API_URL}/agent/${agentId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        );

        return {
            success: true,
            data: response.data
        };
    } catch (error) {
        return {
            success: false,
            error: error.response?.data || error.message
        };
    }
};
